import { RouterActionTypes } from '../actions/router.action.types';
var defaultState = [];
export var UpdateRouteConfigurationReducer = function (state, action) {
    if (state === void 0) { state = defaultState; }
    if (action.type !== RouterActionTypes.UPDATE_ROUTE_CONFIGURATION) {
        return state;
    }
    var application = state.find(function (item) { return item.applicationName == action.payload.applicationName; });
    if (application === null || application === undefined) {
        return state;
    }
    var stateConfig = application.routes.find(function (item) { return item.name == action.payload.stateName; });
    if (stateConfig === null || stateConfig === undefined) {
        return state;
    }
    stateConfig.component = action.payload.component;
    return state.slice();
};
//# sourceMappingURL=updateRouteConfiguration.reducer.js.map